import { createIcon } from '../shared'

const BookmarkIcon = createIcon(
  ({ color }) => (
    <path
      d="M16.6667 1.66675C17.1269 1.66675 17.5 2.03984 17.5 2.50008V17.5001C17.5 17.8329 17.3019 18.1334 16.9963 18.2651C16.6907 18.3967 16.3364 18.3341 16.0946 18.1056L10 12.3463L3.90544 18.1056C3.66358 18.3341 3.30933 18.3967 3.00374 18.2651C2.69814 18.1334 2.5 17.8329 2.5 17.5001V2.50008C2.5 2.03984 2.8731 1.66675 3.33333 1.66675H16.6667ZM4.16667 15.5657L9.4279 10.5942L9.48975 10.5413C9.81069 10.2922 10.2709 10.3098 10.5721 10.5942L15.8333 15.5657V3.33341H4.16667V15.5657Z"
      fill={color}
    />
  ),
  '0 0 20 20',
  'BookmarkIcon',
)

export { BookmarkIcon }
